// Whether the screen is at least 1024px wide (Tailwind's `lg`): for the few places that
// show a different control, not just a different layout, beside or below that width.
import { useSyncExternalStore } from 'react'

const query = typeof window === 'undefined' ? null : window.matchMedia('(min-width: 64rem)')

export function useWide(): boolean {
  return useSyncExternalStore(
    (onChange) => {
      query?.addEventListener('change', onChange)
      return () => query?.removeEventListener('change', onChange)
    },
    () => query?.matches ?? true,
  )
}

const narrowQuery = typeof window === 'undefined' ? null : window.matchMedia('(max-width: 639px)')

/** Whether the screen is a phone's (under 640px): one colour at a time in Sizes & colours. */
export function useNarrow(): boolean {
  return useSyncExternalStore(
    (onChange) => {
      narrowQuery?.addEventListener('change', onChange)
      return () => narrowQuery?.removeEventListener('change', onChange)
    },
    () => narrowQuery?.matches ?? false,
  )
}
